import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-top":"20px"} }

import {onMounted, reactive} from "vue";
import {ref} from "vue";
import {ViewRecordList} from "@/apis/contract/contract.viewRecord.api";
import { useLocales } from '@/hooks/useLocales';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();

const state = reactive({
  data:[] as any,
  search:{
    user_name:'',
    ct_name:'',
    current: 1,
    page_size: 10,
  },
  pageTotal:0,
})


onMounted(  async () => {
  recordSearch()
});

const recordSearch = async () =>{
  const res = await ViewRecordList(state.search);
  state.data = res.data.data
  state.pageTotal = res.data.total;
  console.log('66',res)
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, {
      shadow: "naver",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(state).search,
          ref: "queryFormRef",
          size: "small",
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('contracts.contractName', '合同名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).search.ct_name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search.ct_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('contracts.username', '用户名')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).search.user_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).search.user_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: "Search",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (recordSearch()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('contracts.search', '查询')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      data: _unref(state).data
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "ct_name",
          label: _unref(t)('contracts.contract', '合同')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "user_name",
          label: _unref(t)('contracts.browsingUser', '浏览用户')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "view_time",
          label: _unref(t)('contracts.browsingTime', '浏览时间')
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_pagination, {
        small: "",
        background: "",
        pageSize: _unref(state).search.page_size,
        "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).search.page_size) = $event)),
        currentPage: _unref(state).search.current,
        "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).search.current) = $event)),
        hideOnSinglePage: false,
        layout: 'sizes, prev, pager, next, jumper, ->, total',
        pageSizes: [10, 20, 30, 40, 50, 100],
        pagerCount: 8,
        total: _unref(state).pageTotal
      }, null, 8, ["pageSize", "currentPage", "total"])
    ])
  ]))
}
}

})